import React from 'react'

const Mision = () => {
  return (
    <div id='mision'>
        <br />
        <br />
        <h2 className='text-center'>Misión</h2>
        <p className='text-center'>Proveer al cliente las mejores opciones de la tecnología más actualizada a precios competitivos sin olvidar el buen servicio.</p>
    </div>
  )
}

export default Mision